import StepItem from './StepItem/StepItem';
import { useSelector } from 'react-redux';
import { IApplicationState } from '@spinwise/spinwise-core';

const StepsBlock = ({ step_item }) => {
  const { success } = useSelector((state: IApplicationState) => state.authReducer.auth);
  const currentIndex = success ? 1 : 0;

  return (
    <div>
      {step_item.map(
        (
          {
            id,
            header_title,
            title,
            subtitle,
            icon,
            description,
            btn_text,
            btn_url,
            bonus_terms_text,
            bonus_terms_link,
            availability_text,
            css,
            info_page,
          },
          index,
        ) => (
          <StepItem
            key={id}
            currentIndex={currentIndex}
            index={index}
            header_title={header_title}
            title={title}
            subtitle={subtitle}
            icon={icon}
            description={description}
            btn_text={btn_text}
            btn_url={btn_url}
            bonus_terms_text={bonus_terms_text}
            bonus_terms_link={bonus_terms_link}
            availability_text={availability_text}
            css={css}
            info_page={info_page}
          />
        ),
      )}
    </div>
  );
};

export default StepsBlock;
